export const breakpoints = {
    xs: 0,
    sm: 768,
    md: 1020,
    lg: 1300,
    xl: 1300,
} as const

// This is the same as `theme.breakpoints.down('sm')` but without the leading `@media`
export const mobileMediaQueryString = `(max-width: ${breakpoints.sm - 0.05}px)`

// This is the same as `${theme.breakpoints.up('sm')} and ${theme.breakpoints.down('md')}` but without the leading `@media`
export const mediumScreenMediaQueryString = `(min-width: ${breakpoints.sm}px) and (max-width: ${
    breakpoints.md - 0.05
}px)`

// This is the same as `${theme.breakpoints.up('md')} and ${theme.breakpoints.down('lg')}` but without the leading `@media`
export const largeScreenMediaQueryString = `(min-width: ${breakpoints.md}px) and (max-width: ${
    breakpoints.lg - 0.05
}px)`

// This is the same as `theme.breakpoints.up('sm')` but without the leading `@media`
export const desktopMediaQueryString = `(min-width:${breakpoints.sm}px)`
